var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module_wrap box_border"},[_c('div',{staticClass:"box_title"},[_vm._v("分包商（被保险人）已决案件量TOP6统计")]),_c('div',{attrs:{"id":"case_bar"}})])
}]

export { render, staticRenderFns }